import React from 'react'

// NB : le data est le contenu du champs 'historique' de la table 'piece_argus'

const HistoriquePrixArgus = (data) => {
  const getMonthKey = (date) => {
    const d = new Date(date)
    return `${d.getFullYear()}-${d.getMonth()}`
  }

  const getKeyFromOffset = (offset) => {
    const d = new Date()
    d.setMonth(d.getMonth() + offset)
    return `${d.getFullYear()}-${d.getMonth()}`
  }

  // sécurise si data est null/undefined
  if (!Array.isArray(data) || data.length === 0) {
    return {prixM: 0, prixM1: 0, prixM2: 0, prixM3: 0}
  }

  const map = {}

  data.forEach((d) => {
    if (d?.date && d?.prix) {
      map[getMonthKey(d.date)] = d.prix
    }
  })

  return {
    prixM: map[getKeyFromOffset(0)] ?? 0, // prix du mois actuel
    prixM1: map[getKeyFromOffset(-1)] ?? 0, // prix du mois precedent
    prixM2: map[getKeyFromOffset(-2)] ?? 0, // prix du mois avant precedent
    prixM3: map[getKeyFromOffset(-3)] ?? 0, // prix du mois avant avant precedent
  }
}

export {HistoriquePrixArgus}
